const CUSTOM_INSTRUCTION_EVENT_FIELDS = {
  topicAndDetails: "topic_details",
  draftCaption: "draft_caption",
  copyBrief: "copy_brief",
  creativeBrief: "creative_brief",
  hashtags: "hashtags",
} as const;

export type BrandkitCustomInstructionEventField =
  (typeof CUSTOM_INSTRUCTION_EVENT_FIELDS)[keyof typeof CUSTOM_INSTRUCTION_EVENT_FIELDS];

export function toBrandkitCustomInstructionEventField(
  field: string
): BrandkitCustomInstructionEventField | null {
  if (field in CUSTOM_INSTRUCTION_EVENT_FIELDS) {
    return CUSTOM_INSTRUCTION_EVENT_FIELDS[
      field as keyof typeof CUSTOM_INSTRUCTION_EVENT_FIELDS
    ];
  }

  return null;
}

export function extractBrandkitCustomInstructionEventFields(
  payload: object
): BrandkitCustomInstructionEventField[] {
  return Object.keys(payload)
    .map((field) => toBrandkitCustomInstructionEventField(field))
    .filter(
      (field): field is BrandkitCustomInstructionEventField => field !== null
    );
}
